import React, {ChangeEvent, Component} from 'react';
import {CustomFilterField, CustomFilterLiteralSearch} from "../../../domain/ui/FilterDomains";
import FormicaSearchSelectBox, {FormicaSelectBoxItem} from "../FormicaSearchSelectBox";
import FormicaInput from "../FormicaInput";

class CustomFilterStringLiteralComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const {value, comparison} = this.state;
    return (
      <div className={"flex flex-col items-start justify-center h-auto max-h-44 w-[520px]"}>
        <div className={"flex flex-col gap-y-1 border-b border-b-[#E0E4E8] items-start justify-start w-full px-3 py-3"}>
          <div className={"flex flex-col justify-center w-full items-start gap-y-1"}>
            <p className={"text-sm text-f-black-2"}>Comparison</p>
            <span className={"min-w-[120px] w-full "}>
              <FormicaSearchSelectBox icon={"search"}
                                      value={comparison}
                                      rounded
                                      placeholder={"Comparison"}
                                      options={this.getComparisonOptions()}
                                      onChange={this.onChangeComparison}/>
            </span>
          </div>
          <div className={"flex flex-col w-full justify-center items-start gap-y-1"}>
            <div className="flex items-center justify-between w-full">
              <p className={"text-sm text-f-black-2"}>Value</p>
            </div>
            <FormicaInput onChange={this.onChangeValue} value={value}
              placeholder={this.isRegexComparison(comparison) ? "[a-z].*[0-9]" : "Enter value"}/>
            {this.isRegexComparison(comparison) && value && !this.state.isRegexValid && (
              <p className={"text-xs text-red-500"}>Invalid regex pattern</p>
            )}
          </div>
        </div>
        <div className={"flex px-2 py-3 w-full h-full items-center bg-main-gray"}>
          <button onClick={this.applyFilter}
                  className={"flex items-center justify-center text-sm cursor-pointer w-full h-9 rounded bg-f-purple text-white"}
                  disabled={!this.getApplyButtonIsDisabled()}>
            Apply
          </button>
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const {field} = this.props;
    const {value, operator} = field.search.value as CustomFilterLiteralSearch;
    if ((value || value == "") && operator) {
      this.setState({value: value as string, comparison: operator})
    }
  }

  private isRegexComparison = (comparison: string | undefined): boolean => {
    return comparison === "regex" || comparison === "notRegex";
  }

  private getApplyButtonIsDisabled = () => {
    const {comparison, value, isRegexValid} = this.state;
    if (comparison == "eq" || comparison == "neq") return true;
    if (this.isRegexComparison(comparison) && value && !isRegexValid) return false;
    if (value && value != "") return true;
    return false;
  }

  private getComparisonOptions = (): FormicaSelectBoxItem[] => {
    return [
      {label: "Equal", value: "eq", icon: "equal"},
      {label: "Not Equal", value: "neq", icon: "not-equal"},
      {label: "Contains", value: "contains", icon: "contains"},
      {label: "Starts With", value: "startsWith", icon: "expression_icon_startswith"},
      {label: "Ends With", value: "endsWith", icon: "expression_icon_endswith"},
      {label: "Regex Match", value: "regex", icon: "expression_icon_matches"},
      {label: "Regex Not Match", value: "notRegex", icon: "regexnotmatches"},
    ] as FormicaSelectBoxItem[];
  }

  private onChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    const {comparison} = this.state;
    const isRegexValid = this.isRegexComparison(comparison) ? this.validateRegex(value) : true;
    this.setState({ value, isRegexValid });
  }

  private onChangeComparison = (event: FormicaSelectBoxItem) => {
    const {value} = this.state;
    const isRegexValid = this.isRegexComparison(event.value) ? this.validateRegex(value ?? "") : true;
    this.setState({ comparison: event.value, comparisonIcon: event.icon, isRegexValid });
  }

  private validateRegex = (pattern: string): boolean => {
    if (!pattern || pattern.trim() === "") return true;
    try {
      new RegExp(pattern);
      return true;
    } catch {
      return false;
    }
  }

  private applyFilter = () => {
    const {comparison, value} = this.state;
    const {onChange, field, onApply} = this.props;
    (field.search.value as CustomFilterLiteralSearch).value = value || "";
    (field.search.value as CustomFilterLiteralSearch).operator = comparison || "";
    onChange();
    onApply();
  }
}

interface Props {
  field: CustomFilterField;
  onChange: VoidFunction;
  onApply: () => void;
}

class State {
  value: string | undefined = undefined;
  comparison: string | undefined = undefined;
  comparisonIcon: string | undefined;
  isRegexValid: boolean = true;
}

export default CustomFilterStringLiteralComponent;
